/* eslint-disable no-alert, no-console */ /* eslint-disable no-duplicate-imports */
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '../../client'
import type { RequestConfig, ResponseErrorConfig } from '../../client'
import type { PostApiLoginMutationRequest, PostApiLoginMutationResponse } from '../models/PostApiLogin'

function getPostApiLoginUrl() {
  return `/api/login.json` as const
}

/**
 * @description Danish: Log ind
 * @summary Login
 * {@link /api/login.json}
 */
export async function postApiLogin(
  data?: PostApiLoginMutationRequest,
  config: Partial<RequestConfig<PostApiLoginMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PostApiLoginMutationResponse, ResponseErrorConfig<Error>, PostApiLoginMutationRequest>({
    method: 'POST',
    url: getPostApiLoginUrl().toString(),
    data,
    ...requestConfig,
  })
  return res.data
}